<div class="header">
	<div class="close-button" (click)="close.emit()">
		<div class="cross">
			<div class="line-v"></div>
			<div class="line-h"></div>
		</div>
	</div>
	<div class="back-pattern">
		<div class="quarter-circle"><div class="circle"></div></div>
		<div class="half-circle">
			<img
				src="/assets/img/whitespots_cropped_image.png"
				class="spots-white-in-circle"
			/>
		</div>
	</div>
	<div class="header-content">
			Get a call back
	</div>
</div>
<div [ngClass]="{'content':true, 'content-simkit':source==='simkit'}"><ng-content select="[content]"></ng-content></div>
